import TheMapHoverPopup from "../components/Map/TheMapHoverPopup";
import mapboxgl from "mapbox-gl";
import Vue from "vue";
import vuetify from "../../plugins/vuetify";
import store from "../../core/store/store";
import i18n from "../../i18n";
import router from "../../router";

// Global Variables for hover popup
// check if program is allowed to close hover popup
let CLOSE_HOVER_POPUP = true;
// check if hover popup is displayed
let IS_HOVER_POPUP_DISPLAY = false;
let CURRENT_LOCATION_ID = NaN;

/* Popups SECTION */
let hoverPopup = new mapboxgl.Popup({
  offset: 32,
  closeButton: false,
  closeOnClick: false,
  maxWidth: "none"
});
/* Vuejs components used for popup content */
const TheMapHoverPopupClass = Vue.extend(TheMapHoverPopup);

export default {
  /* event trigger by hovering a layer ==> display the Hover popup */
  setDesktopHoverEvent(map) {
    map.on("displayHoverPopup", e => {
      CLOSE_HOVER_POPUP = false;
      if (!IS_HOVER_POPUP_DISPLAY || CURRENT_LOCATION_ID !== e.features[0].id) {
        let coordinates = e.features[0].geometry.coordinates.slice();
        hoverPopup
          .setHTML('<div id="vue-popup-content"></div>')
          .setLngLat(coordinates)
          .addTo(map);
        const hoverPopupInstance = new TheMapHoverPopupClass({
          i18n,
          vuetify,
          store,
          router,
          propsData: {
            properties: JSON.parse(JSON.stringify(e.features[0].properties))
          }
        });
        hoverPopupInstance.$mount("#vue-popup-content");
        hoverPopup._update();
        IS_HOVER_POPUP_DISPLAY = true;
        CURRENT_LOCATION_ID = e.features[0].id;
      }
    });
    map.on("click", "desktopDestinations", e => {
      var bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      const features = map.queryRenderedFeatures(bbox, {
        layers: ["desktopDestinations"]
      });
      map.fire("displayDestinationPage", {
        destinationId: features[0].properties.destinationId
      });
    });
    map.on("click", "highlight-desktopDestinations", e => {
      var bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      const features = map.queryRenderedFeatures(bbox, {
        layers: ["desktopDestinations"]
      });
      map.fire("displayDestinationPage", {
        destinationId: features[0].properties.destinationId
      });
    });
    /* event triger when mouse stop hover a layer ==> remove the hover PopUp */
    map.on("removeHoverPopup", () => {
      CLOSE_HOVER_POPUP = true;
      setTimeout(() => {
        if (CLOSE_HOVER_POPUP) {
          hoverPopup.remove();
          IS_HOVER_POPUP_DISPLAY = false;
        }
      }, 200);
    });
    map.on("removeHighlightDestination", () => {
      const layer = map.getLayer("highlight-desktopDestinations");
      if (typeof layer !== "undefined") {
        // Remove map layer & source.
        map
          .removeLayer("highlight-desktopDestinations")
          .removeSource("highlight-desktopDestinations");
      }
    });
  },
  setMobileTouchEvent(map) {
    // When a click/touch event occurs on a feature in the places layer triggers a displayDestinationPageEvent
    map.on("click", "MobileDestinations", e => {
      var bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      const features = map.queryRenderedFeatures(bbox, {
        layers: ["MobileDestinations"]
      });
      map.fire("displayDestinationPage", {
        destinationId: features[0].properties.destinationId
      });
    });
  },
  setCloseHoverPopupToFalse() {
    CLOSE_HOVER_POPUP = false;
  },
  closeHoverPopup() {
    CLOSE_HOVER_POPUP = true;
    IS_HOVER_POPUP_DISPLAY = false;
    hoverPopup.remove();
  }
};
